import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ConfirmationService, MessageService } from 'primeng/api';
import { BreadcrumbService } from 'src/app/app.breadcrumb.service';
import { AbstractService } from 'src/app/services/abstract.service';
import { AjudaRotinaService } from 'src/app/services/ajuda-rotina.service';

@Component({
  selector: 'habil-ajuda-rotina',
  templateUrl: './ajuda-rotina.component.html',
  styleUrls: ['./ajuda-rotina.component.scss'],
  providers: [ConfirmationService, MessageService],
})
export class AjudaRotinaComponent implements OnInit {
  constructor(
    private breadcrumbService: BreadcrumbService,
    public service: AjudaRotinaService,
    titleService: Title
  ) {
    this.breadcrumbService.setItems([{ label: 'Ajuda das rotinas' }]);
    titleService.setTitle('Ajuda das rotinas - ' + AbstractService.app);
  }

  ngOnInit(): void {}
}
